import React, { useEffect } from 'react';
import { Buttons, Form, LabelText, NoteText, StyledButton } from './CryptoForm.styles';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Input from '../../utils/inputs/Input/Input';
import { CRYPTO_NETWORK, WITHDRAWAL_METHOD_TYPE } from '../../../utils/constants';
import CryptoNetworkButton from '../CryptoNetworkButton/CryptoNetworkButton';
import { handleWithdrawalMethods } from '../../../store/slices/user/asyncThunks';
import { WITHDRAW } from '../../App/routes';
import { notifyError } from '../../../utils/notify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserActionsPending } from '../../../store/slices/user/slice';
import { useConfirmationModal } from '../../modals/ConfirmationModal/ConfirmationModal';

export const cryptoFormSchema = yup
  .object({
    address: yup.string().trim().required('Address is required'),
  })
  .required();

const CryptoForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleWithdrawalMethods: handleWithdrawalMethodsPending } = useSelector(selectUserActionsPending);
  const [openModal, closeModal, setConfirmationModalLoader] = useConfirmationModal();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      address: '',
      network: CRYPTO_NETWORK.TRC_20,
    },
    delayError: 300,
    resolver: yupResolver(cryptoFormSchema),
  });

  useEffect(() => {
    setConfirmationModalLoader(handleWithdrawalMethodsPending);
    // eslint-disable-next-line
  }, [handleWithdrawalMethodsPending]);

  const onSubmit = data => {
    openModal(
      'Confirm Banking Details',
      `Please make sure everything’s correct. You can change it later by deleting and adding new details.`,
      'Confirm & Save',
      () => {
        dispatch(handleWithdrawalMethods({ ...data, withdrawalMethodType: WITHDRAWAL_METHOD_TYPE.CRYPTO }))
          .unwrap()
          .then(() => {
            closeModal();
            navigate(`/${WITHDRAW}`);
          })
          .catch(err => {
            notifyError(err.message);
          });
      },
      'Go Back',
      () => {
        closeModal();
      },
    );
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Input
        label="USDT Address"
        placeholder="Enter USDT Address"
        {...register('address')}
        error={errors.address?.message}
      />
      <LabelText>Network</LabelText>
      <Controller
        name="network"
        control={control}
        render={({ field }) => (
          <Buttons>
            {Object.keys(CRYPTO_NETWORK).map(key => (
              <CryptoNetworkButton
                key={key}
                title={key.replace('_', ' ')}
                selected={field.value === key}
                onClick={() => field.onChange(key)}
              />
            ))}
          </Buttons>
        )}
      />
      <NoteText>
        Please ensure that the address you provide is correct. Cryptocurrency transactions are irreversible, and funds
        sent to an incorrect address cannot be recovered.
      </NoteText>
      <StyledButton title="Save" type="submit" isLoading={handleWithdrawalMethodsPending} />
    </Form>
  );
};

export default CryptoForm;
